import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import ComponentRenderer from 'shared/renderer/ChildNodeRenderer/ComponentRenderer/ComponentRenderer';
import { VXLComponent } from 'shared/renderer/types';

interface ComponentGroupProps
  extends Pick<
    ViewStyle,
    'alignItems' | 'padding' | 'gap' | 'backgroundColor'
  > {
  components: VXLComponent[];
}

/**
 * A generic container which composes one or many child components together and provides
 * external padding, alignment and inter-item spacing. This group is used for composing
 * heterogeneous components together in a layout. For homogeneous groups check w/ design
 * about a type specific component group.
 */
const ComponentGroup = ({
  alignItems,
  components,
  padding,
  gap,
  backgroundColor,
}: ComponentGroupProps) => {
  return (
    <View
      style={[styles.container, { alignItems, padding, gap, backgroundColor }]}
    >
      {components.map((component) => {
        return (
          <ComponentRenderer
            key={`${component.name}-${component.id}`}
            toRender={component}
          />
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default ComponentGroup;
